<!-- Overlay loading -->
<app-fullscreen-overlay
  [isOverlayLoading]="isOverlayLoading"
></app-fullscreen-overlay>

<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div id="kt_app_content_container" class="app-container container-fluid">
      <div class="row gx-5 gx-xl-10 px-5">
        <div class="card mb-5 mb-xl-8">
          <div class="card-header border-0 pt-5">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label fw-bold fs-3 mb-1">{{
                "editPushNotifications" | translate
              }}</span>
            </h3>
          </div>

          <div class="card-body py-3 pb-6">
            <form
              [formGroup]="notificationForm"
              (ngSubmit)="saveNotification($event)"
            >
              <div class="row">
                <!-- English Area -->
                <div class="col-md-6">
                  <p class="fw-bold">{{ "english" | translate }}</p>
                  <!-- Subject -->
                  <div class="form-floating">
                    <input
                      formControlName="subjectEn"
                      type="text"
                      class="form-control"
                      id="inputSubjectEn"
                      placeholder="subject"
                      required
                    />
                    <label for="inputSubjectEn">{{
                      "subject" | translate
                    }}</label>
                    <div
                      *ngIf="isControlInvalid('subjectEn')"
                      class="text-danger"
                    >
                      <ng-container
                        *ngIf="
                          notificationForm
                            .get('subjectEn')
                            ?.hasError('required')
                        "
                      >
                        {{ "subjectIsRequired" | translate }}
                      </ng-container>
                    </div>
                  </div>
                  <!-- Body -->
                  <div class="form-floating my-6">
                    <textarea
                      formControlName="bodyEn"
                      type="text"
                      class="form-control text-area-height"
                      id="inputBodyEn"
                      placeholder="{{ 'body' | translate }}"
                      required
                      rows="10"
                    ></textarea>
                    <label for="inputBodyEn">{{ "body" | translate }}</label>
                    <div *ngIf="isControlInvalid('bodyEn')" class="text-danger">
                      <ng-container
                        *ngIf="
                          notificationForm.get('bodyEn')?.hasError('required')
                        "
                      >
                        {{ "bodyIsRequired" | translate }}
                      </ng-container>
                    </div>
                  </div>
                </div>
                <!-- Dutch Area -->
                <div class="col-md-6">
                  <p class="fw-bold">{{ "dutch" | translate }}</p>
                  <!-- Subject -->
                  <div class="form-floating">
                    <input
                      formControlName="subjectNl"
                      type="text"
                      class="form-control"
                      id="inputSubjectNl"
                      placeholder="subject"
                      required
                    />
                    <label for="inputSubjectNl">{{
                      "subject" | translate
                    }}</label>
                    <div
                      *ngIf="isControlInvalid('subjectNl')"
                      class="text-danger"
                    >
                      <ng-container
                        *ngIf="
                          notificationForm
                            .get('subjectNl')
                            ?.hasError('required')
                        "
                      >
                        {{ "subjectIsRequired" | translate }}
                      </ng-container>
                    </div>
                  </div>
                  <!-- Body -->
                  <div class="form-floating my-6">
                    <textarea
                      formControlName="bodyNl"
                      type="text"
                      class="form-control text-area-height"
                      id="inputBodyNl"
                      placeholder="{{ 'body' | translate }}"
                      required
                      rows="10"
                    ></textarea>
                    <label for="inputBodyNl">{{ "body" | translate }}</label>
                    <div *ngIf="isControlInvalid('bodyNl')" class="text-danger">
                      <ng-container
                        *ngIf="
                          notificationForm.get('bodyNl')?.hasError('required')
                        "
                      >
                        {{ "bodyIsRequired" | translate }}
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="text-end">
                  <button
                    [routerLink]="['/notification-contents/push']"
                    type="button"
                    class="btn btn-sm btn-secondary cursor-pointer"
                  >
                    {{ "cancel" | translate }}
                  </button>
                  <button
                    type="submit"
                    class="btn btn-sm btn-dark cursor-pointer ms-3"
                  >
                    {{ "save" | translate }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
